import { SET_OPEN_BANKING_SECURE_KEY } from "../const";
export function setRSAKey(key: string) {
  return {
      type: SET_OPEN_BANKING_SECURE_KEY,
      payload: key
  };
}